import { Svg } from 'components/svg'

export const VideoIcon = () => (
  <Svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g id="Group_1" data-name="Group 1" transform="translate(1.518 3.045)">
      <rect
        width="17.365"
        height="12.534"
        rx="2"
        transform="translate(1.8 1.059)"
        fill="none"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path d="M13.739,7.325l-4.885,2.82V4.5Z" fill="currentColor" />
      <path
        d="M5.938,16.851h9.088"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="2"
      />
    </g>
  </Svg>
)
